import { isArray, isNil } from 'lodash-es';
import React from 'react';

import { MayBeArray } from 'app/@types/utils/may-be-array';
import { useUserInfo } from 'queries/user-action/use-user-info';

import { presets } from './constants';
import { Type } from './types';

interface Props {
    licenses?: MayBeArray<`${Type}`>;
    enabled?: boolean;
    anonymous?: boolean;
    children?: React.ReactNode;
    fallback?: React.ReactNode;
}

const LicenseGuard: React.FC<Props> = ({ licenses, enabled = true, anonymous = false, fallback, children }) => {
    const { isLoading, data: user } = useUserInfo();

    if (enabled === false) {
        return children;
    }

    if (isLoading) {
        return null;
    }

    if (isNil(user)) {
        return anonymous ? children : fallback ?? null;
    }

    const isVisible = user.licenses.some((license) => {
        let output = true;

        if (licenses) {
            if (isArray(licenses)) {
                output ||= licenses.some((type) => presets[type](license));
            } else {
                output ||= presets[licenses](license);
            }
        }

        return output;
    });

    return isVisible ? children : fallback ?? null;
};

export default LicenseGuard;
